import { render, staticRenderFns } from "./StatisticsService.vue?vue&type=template&id=d9376566&scoped=true&"
import script from "./StatisticsService.vue?vue&type=script&lang=js&"
export * from "./StatisticsService.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsService.vue?vue&type=style&index=0&id=d9376566&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9376566",
  null
  
)

export default component.exports